import React from 'react'
import HomeBanner from './home/HomeBanner'
import HomeAbout from './home/HomeAbout'
// import HomeAbout from './home/HomeAbout'
// import MissionVision from './home/MissionVision'
import HomeWorkingProcess from './home/HomeWorkingProcess'
import ChooseUs from './home/ChooseUs'
import HomeMDMessage from './home/HomeMDMessage'
import HomeTestimonials from './home/HomeTestimonials'
import OurPortfolio from './home/OurPortfolio'
import HomeServices from './home/HomeServices'
import HomeBlog from './home/HomeBlog'
import Accreditations from './home/Accreditations'
import Certificates from './home/Certificates'
import BestProducts from './home/BestProducts'




const Home = () => {
  return (
    <>
      <div>
        <HomeBanner />
        {/* <HomeMDMessage /> */}
        <HomeAbout />
        <BestProducts />
        <Accreditations />
        <ChooseUs />
        <HomeWorkingProcess />
        <HomeServices />
        <HomeTestimonials />
        <Certificates />
        <HomeBlog />
        <OurPortfolio />
        
      </div>






    </>
  )
}

export default Home